// extracted by mini-css-extract-plugin
export default {"teamheader":"about_teamheader__1ycMT","teamlinks":"about_teamlinks__hy-8z","btn":"about_btn__4S0fF","h3":"about_h3__87X30","scroll":"about_scroll__QsU2k"};